export default [
  {
    "label": "Terra Vermelha p/ cobertura (saco 25 kg)"
  },
  {
    "label": "Terra Preta p/ cobertura (saco 25 kg)"
  },
  {
    "label": "Terra Mista p/ cobertura (saco 25 kg)"
  },
  {
    "label": "Estacas de Bambú p/ fixação em taludes (1.000 unid)"
  },
  {
    "label": "Calcário Dolomitico 40 kg"
  }
]